/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import NewsContainer, { News } from './News';

/**
 * News module exports
 */
export {
    News,
    NewsContainer as default
};



// WEBPACK FOOTER //
// ./src/js/News/index.js